module.exports = __webpack_public_path__ + "img/opera.f5a17efe.png";